/**
 * Active Stripe publishable key helper (Task #1643).
 *
 * Picks the correct `pk_...` key based on `VITE_STRIPE_MODE`:
 *   - `VITE_STRIPE_MODE=test`  → VITE_STRIPE_PUBLISHABLE_TEST_KEY
 *   - anything else (or unset) → VITE_STRIPE_PUBLISHABLE_KEY  (live)
 *
 * Both env vars are baked into the client bundle by Vite at build time.
 * Switching modes requires changing both STRIPE_MODE and VITE_STRIPE_MODE,
 * restarting the workflow (which triggers a Vite rebuild), then hard-refreshing
 * the browser.
 *
 * Import this helper everywhere you need a Stripe publishable key instead of
 * reading `import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY` directly.
 */

// The dev server (Replit preview) may override the shared VITE_STRIPE_MODE via
// VITE_STRIPE_MODE_DEV, mirroring STRIPE_MODE_DEV on the server. Production
// builds (import.meta.env.DEV === false) always use VITE_STRIPE_MODE.
const _devMode = import.meta.env.DEV
  ? (import.meta.env.VITE_STRIPE_MODE_DEV as string | undefined)?.trim().toLowerCase()
  : undefined;
const _mode =
  _devMode === "test" || _devMode === "live"
    ? _devMode
    : (import.meta.env.VITE_STRIPE_MODE as string | undefined)?.trim().toLowerCase();
const _liveKey = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY as string | undefined;
const _testKey = import.meta.env.VITE_STRIPE_PUBLISHABLE_TEST_KEY as string | undefined;

export function getActiveStripePublishableKey(): string | undefined {
  if (_mode === "test") return _testKey || undefined;
  return _liveKey || undefined;
}

export const ACTIVE_STRIPE_MODE: "test" | "live" = _mode === "test" ? "test" : "live";
